
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageCircle, ArrowRightCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const buddies = [
  { 
    name: 'Nouri', 
    description: 'Helpt je met vrienden maken', 
    longDescription: 'Nouri is jouw vrolijke gids in de wereld van vriendschap. Samen ontdekken jullie hoe je makkelijk contact legt, vriendschappen sluit en onderhoudt. Met Nouri aan je zijde voel je je nooit alleen!',
    imageSrc: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/e926ce51-6e11-4ab9-9fdf-60980d54863c/36bcc828609374cccfea37437b0087b4.png', 
    imageDescription: 'Vrolijk icoon van Nouri, een AI buddy die helpt met sociale vaardigheden en vriendschap.',
    gradientFrom: 'from-blue-400',
    gradientTo: 'to-blue-600',
    textColor: 'text-white',
    exampleQuestion: "Ik voel me altijd alleen in de pauze. Niemand speelt met mij.",
    exampleResponse: "Dat klinkt eenzaam, en ik begrijp dat dat vervelend voelt. Weet je wat vaak helpt? Kijk eens wie er alleen staat of rustig speelt - misschien willen zij ook graag een speelmaatje! Je kunt ook vragen: 'Mag ik meedoen?' Veel kinderen vinden dat leuk. Wat zou jij het liefst willen spelen?"
  },
  { 
    name: 'Luma', 
    description: 'Helpt je met angst en spanning', 
    longDescription: 'Luma is een baken van rust. Als je je angstig of gespannen voelt, helpt Luma je met kalmerende oefeningen en positieve gedachten. Samen vinden jullie de weg naar innerlijke vrede.',
    imageSrc: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/e926ce51-6e11-4ab9-9fdf-60980d54863c/64410c4a8456aa01d48bf1fcccc62851.png', 
    imageDescription: 'Zachtaardig icoon van Luma, een AI buddy die helpt bij angst en spanning met kalmerende oefeningen.',
    gradientFrom: 'from-yellow-400',
    gradientTo: 'to-yellow-600',
    textColor: 'text-white',
    exampleQuestion: "Ik ben zo zenuwachtig voor de toets morgen. Mijn buik doet pijn van de stress.",
    exampleResponse: "Ik merk dat je je zorgen maakt over de toets, en dat is heel normaal! Laten we samen je zenuwachtigheid wat minder maken. Adem eens langzaam in door je neus... en uit door je mond. Goed zo! Heb je al geoefend voor de toets? Meestal gaat het beter dan we denken."
  },
  { 
    name: 'Rafi', 
    description: 'Helpt je met keuzes maken en zelfvertrouwen opbouwen', 
    longDescription: 'Rafi is je slimme steunpilaar. Bij lastige keuzes of als je zelfvertrouwen een boost nodig heeft, staat Rafi voor je klaar. Samen ontdekken jullie je sterke kanten en leer je op jezelf te vertrouwen.',
    imageSrc: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/e926ce51-6e11-4ab9-9fdf-60980d54863c/e0628690ae18b65afa2ea44c952b4171.png', 
    imageDescription: 'Slim icoon van Rafi, een AI buddy die kinderen helpt met beslissingen nemen en zelfvertrouwen opbouwen.',
    gradientFrom: 'from-purple-400',
    gradientTo: 'to-purple-600',
    textColor: 'text-white',
    exampleQuestion: "Ik durf nooit mijn vinger op te steken in de klas, ook al weet ik het antwoord.",
    exampleResponse: "Wat knap dat je vaak het antwoord weet! Dat laat zien hoe slim je bent. Het is heel normaal om zenuwachtig te zijn om je vinger op te steken. Misschien kun je beginnen met iets kleins - bijvoorbeeld bij een vraag waar je heel zeker van bent? Of vraag de juf of je het antwoord mag fluisteren. Kleine stapjes zijn ook echte stappen vooruit!"
  },
  { 
    name: 'Zena', 
    description: 'Praat over gevoelens', 
    longDescription: 'Zena is je luisterend oor. Of je nu blij, boos, verdrietig of verward bent, Zena biedt een veilige plek om al je gevoelens te uiten en te begrijpen. Geen gevoel is te gek voor Zena!',
    imageSrc: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/e926ce51-6e11-4ab9-9fdf-60980d54863c/5be273ac8daf84ec650dbc720f5bc36f.png', 
    imageDescription: 'Warm icoon van Zena, een AI buddy die een veilige ruimte biedt om over allerlei gevoelens te praten.',
    gradientFrom: 'from-pink-400',
    gradientTo: 'to-pink-600',
    textColor: 'text-white',
    exampleQuestion: "Ik word heel boos als iemand tegen me zegt dat ik iets niet goed doe.",
    exampleResponse: "Boos worden is een normaal gevoel, en het is oké om je zo te voelen! Je hart klopt misschien sneller en je voelt je warm worden, klopt dat? Dat is je lichaam dat reageert. Wat zou je kunnen doen als je merkt dat je boos wordt? Misschien even diep ademhalen of tot 10 tellen voordat je reageert?"
  },
  { 
    name: 'Appie', 
    description: 'Helpt bij problemen met pesten', 
    longDescription: 'Appie is je dappere beschermer. Als je te maken hebt met pesten, online of offline, helpt Appie je om sterk te staan en de juiste stappen te zetten. Samen staan jullie sterker tegen pesten.',
    imageSrc: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/e926ce51-6e11-4ab9-9fdf-60980d54863c/32a7bab3949898c8b91390aea3b3cebc.png', 
    imageDescription: 'Sterk icoon van Appie, een AI buddy die kinderen ondersteunt en helpt bij (online) pesten.',
    gradientFrom: 'from-green-400',
    gradientTo: 'to-green-600',
    textColor: 'text-white',
    exampleQuestion: "Er zijn kinderen die me uitschelden en me pijn doen. Ik durf het niet te vertellen.",
    exampleResponse: "Het spijt me dat dit gebeurt. Dat moet heel naar zijn en je bent dapper dat je het met mij deelt. Wat je meemaakt is niet oké - niemand mag je pijn doen of uitschelden. Het is belangrijk dat een volwassene hiervan weet. Kun je het aan je ouders, juf of meester vertellen? Ik help je bedenken wat je kunt zeggen."
  },
  { 
    name: 'Chloe', 
    description: 'Praat over thuis en veranderingen', 
    longDescription: 'Chloe is je begripvolle vriendin. Bij veranderingen thuis, zoals een verhuizing of nieuwe gezinssituaties, biedt Chloe een luisterend oor en helpt ze je om te gaan met de nieuwe situatie.',
    imageSrc: 'https://storage.googleapis.com/hostinger-horizons-assets-prod/e926ce51-6e11-4ab9-9fdf-60980d54863c/6fa70f008d66b5c3004d0717a1bb1874.png', 
    imageDescription: 'Betrouwbaar icoon van Chloe, een AI buddy die luistert en helpt bij veranderingen thuis of familieproblemen.',
    gradientFrom: 'from-orange-400',
    gradientTo: 'to-orange-600',
    textColor: 'text-white',
    exampleQuestion: "Mijn ouders maken veel ruzie en ik weet niet wat ik moet doen.",
    exampleResponse: "Wat vervelend dat je ouders ruziemaken. Dat kan eng en verdrietig zijn om mee te maken. Het is belangrijk dat je weet dat dit niet jouw schuld is - volwassenen maken soms ruzie en dat heeft niets met jou te maken. Hoe voel je je als dit gebeurt? En is er een volwassene met wie je hierover kunt praten, zoals een oma, opa, tante of juf?"
  },
];

const BuddiesPage = () => {
  const [selectedBuddy, setSelectedBuddy] = useState(null);
  
  const fadeIn = (delay = 0) => ({
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, delay, ease: [0.6, -0.05, 0.01, 0.99] } },
  });

  return (
    <div className="container mx-auto px-4 py-16 sm:py-24">
      <motion.div
        initial="hidden"
        animate="visible"
        className="text-center mb-16"
      >
        <motion.h1
          variants={fadeIn()}
          className="page-title"
        >
          Ontmoet onze <span className="text-cm-pink font-medium">Buddy's</span>
        </motion.h1>
        <motion.p
          variants={fadeIn(0.2)}
          className="page-subtitle"
        >
          Elke buddy is uniek en staat klaar om kinderen te ondersteunen bij hun dagelijkse avonturen en uitdagingen. Klik op een buddy om een voorbeeldgesprek te zien!
        </motion.p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {buddies.map((buddy, index) => (
          <motion.div
            key={buddy.name}
            variants={fadeIn(0.4 + index * 0.15)}
            initial="hidden"
            animate="visible"
            whileHover={{ y: -12, boxShadow: "0px 20px 30px -10px rgba(0,0,0,0.2)" }}
            className="h-full cursor-pointer"
            onClick={() => setSelectedBuddy(buddy)}
          >
            <Card className={`glassmorphism-card relative overflow-hidden h-full flex flex-col bg-gradient-to-br ${buddy.gradientFrom} ${buddy.gradientTo} shadow-2xl rounded-3xl border-none transition-all duration-300 hover:scale-105`}>
              <CardHeader className="items-center text-center pt-10 pb-6">
                <motion.div 
                  className="mb-6 p-2 bg-white/30 rounded-full shadow-lg"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <img 
                    alt={buddy.imageDescription}
                    className="w-32 h-32 sm:w-36 sm:h-36 object-contain rounded-full"
                    src={buddy.imageSrc} 
                  />
                </motion.div>
                <CardTitle className={`font-sans font-medium text-4xl ${buddy.textColor}`}>{buddy.name}</CardTitle>
              </CardHeader>
              <CardContent className="text-center pb-10 px-6 flex-grow flex flex-col justify-between">
                <p className={`text-lg ${buddy.textColor} opacity-90 font-semibold mb-6`}>{buddy.longDescription}</p>
                <div className="flex items-center justify-center bg-white/20 rounded-xl p-3">
                  <MessageCircle size={20} className={buddy.textColor} />
                  <span className={`ml-2 text-sm font-medium ${buddy.textColor}`}>Klik voor voorbeeldgesprek</span>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>

      {/* Example Conversation Modal */}
      <AnimatePresence>
        {selectedBuddy && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
            onClick={() => setSelectedBuddy(null)}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="glassmorphism-card max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 rounded-3xl shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center mb-6">
                <img 
                  alt={selectedBuddy.imageDescription}
                  className="w-16 h-16 object-contain rounded-full mr-4"
                  src={selectedBuddy.imageSrc} 
                />
                <div>
                  <h2 className="text-3xl font-sans font-medium text-cm-blue-dark">{selectedBuddy.name}</h2>
                  <p className="text-cm-gray">{selectedBuddy.description}</p>
                </div>
              </div>

              <div className="space-y-6">
                <h3 className="text-xl font-medium text-cm-blue-dark mb-4">Voorbeeldgesprek:</h3>
                
                <div className="bg-cm-blue-light/20 rounded-xl p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-cm-gray rounded-full flex items-center justify-center text-white text-sm font-medium">K</div>
                    <div className="flex-1">
                      <div className="text-sm text-cm-gray mb-1">Kind:</div>
                      <div className="text-cm-blue-dark">{selectedBuddy.exampleQuestion}</div>
                    </div>
                  </div>
                </div>

                <div className={`bg-gradient-to-r ${selectedBuddy.gradientFrom} ${selectedBuddy.gradientTo} rounded-xl p-4`}>
                  <div className="flex items-start space-x-3">
                    <img 
                      alt={selectedBuddy.imageDescription}
                      className="w-8 h-8 object-contain rounded-full"
                      src={selectedBuddy.imageSrc} 
                    />
                    <div className="flex-1">
                      <div className={`text-sm ${selectedBuddy.textColor} opacity-80 mb-1`}>{selectedBuddy.name}:</div>
                      <div className={selectedBuddy.textColor}>{selectedBuddy.exampleResponse}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-cm-gray/20">
                <p className="text-sm text-cm-gray mb-4">
                  Dit is een voorbeeld van hoe {selectedBuddy.name} kinderen helpt. Elk gesprek is uniek en wordt afgestemd op wat het kind nodig heeft.
                </p>
                <Button 
                  onClick={() => setSelectedBuddy(null)}
                  className="w-full bg-gradient-to-r from-cm-pink to-cm-blue hover:from-cm-pink-dark hover:to-cm-blue-dark text-white font-medium py-3 rounded-xl"
                >
                  Sluiten
                </Button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Call to Action */}
      <motion.div
        variants={fadeIn(1.5)}
        initial="hidden"
        animate="visible"
        className="mt-20 p-10 bg-gradient-to-r from-cm-green-light/70 via-cm-yellow-light/70 to-cm-pink-light/70 rounded-3xl shadow-2xl text-center"
      >
        <h2 className="text-4xl font-sans font-medium text-cm-blue-dark mb-5">Geef elk kind een buddy</h2>
        <p className="text-lg text-cm-gray mb-8 max-w-2xl mx-auto leading-relaxed">
          Elke buddy staat klaar om kinderen te helpen bij hun unieke uitdagingen. Vraag een demo aan en ontdek hoe Classbuddy het verschil kan maken op uw school.
        </p>
        <Button asChild size="lg" className="bg-gradient-to-r from-cm-pink to-cm-blue hover:from-cm-pink-dark hover:to-cm-blue-dark text-white font-medium text-lg px-10 py-7 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-300 group">
          <Link to="/contact?subject=DemoAanvraag">
            Vraag een demo aan <ArrowRightCircle className="ml-2.5 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>
      </motion.div>
    </div>
  );
};

export default BuddiesPage;
